import React from "react";

import { incomplete, truncateCredits } from "utils";

import { Button, Col, Drawer, Form, InputNumber, Option, Row, Select } from "components";

export const ModulesAssignmentDrawer = ({
  showAssignmentDrawer,
  handleCloseAssignmentDrawer,
  form,
  complete,
  currentFarmFieldModule,
  remainingModuleCredits,
  handlePartnerChange,
  partners,
  currentPartner,
  remainingPartnerCredits,
  quantity,
  setCreditQuantity,
  loading,
}) => {
  const { category1, category2, category3, category4 } = quantity;

  return (
    <Drawer title="Assign module credits to partner" visible={showAssignmentDrawer} onClose={handleCloseAssignmentDrawer}>
      <Form name="creditAssignment" onFinish={complete} onFinishFailed={incomplete} ref={form} onValuesChange={(_, v) => setCreditQuantity(v)}>
        <Row>
          <Col>
            <span className="paragraph-s grey-text">Farm</span>
            <p>{currentFarmFieldModule.farmName}</p>
            <span className="paragraph-s grey-text">Field</span>
            <p>{currentFarmFieldModule.fieldName}</p>
            <span className="paragraph-s grey-text">Module</span>
            <p>{currentFarmFieldModule.moduleName}</p>
            <span className="paragraph-s grey-text">Completed</span>
            <p>{currentFarmFieldModule.completed.toString()}</p>
            <span className="paragraph-s grey-text">Total Module Credits</span>
            <p>{truncateCredits(currentFarmFieldModule.totalCredits)}</p>
          </Col>
        </Row>
        <p className="center">Assigned Module Credits</p>
        <Row className="center">
          <Col sm={6} md={6}>
            <span className="paragraph-s grey-text">category 1</span>
            <p>{truncateCredits(currentFarmFieldModule.assignedCreditsCategory1)}</p>
          </Col>
          <Col sm={6} md={6}>
            <span className="paragraph-s grey-text">category 2</span>
            <p>{truncateCredits(currentFarmFieldModule.assignedCreditsCategory2)}</p>
          </Col>
          <Col sm={6} md={6}>
            <span className="paragraph-s grey-text">category 3</span>
            <p>{truncateCredits(currentFarmFieldModule.assignedCreditsCategory3)}</p>
          </Col>
          <Col sm={6} md={6}>
            <span className="paragraph-s grey-text">category 4</span>
            <p>{truncateCredits(currentFarmFieldModule.assignedCreditsCategory4)}</p>
          </Col>
        </Row>
        <p className="center">Remaining Module Credits</p>
        <Row className="center">
          <Col sm={6} md={6}>
            <span className="paragraph-s grey-text">category 1</span>
            <p>{truncateCredits(remainingModuleCredits.category1)}</p>
          </Col>
          <Col sm={6} md={6}>
            <span className="paragraph-s grey-text">category 2</span>
            <p>{truncateCredits(remainingModuleCredits.category2)}</p>
          </Col>
          <Col sm={6} md={6}>
            <span className="paragraph-s grey-text">category 3</span>
            <p>{truncateCredits(remainingModuleCredits.category3)}</p>
          </Col>
          <Col sm={6} md={6}>
            <span className="paragraph-s grey-text">category 4</span>
            <p>{truncateCredits(remainingModuleCredits.category4)}</p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Select label="Select a partner" name="partnerId" rules={[{ required: true }]} message={"This is required"} onChange={handlePartnerChange}>
              {partners.map((partner, i) => (
                <Option value={partner.id} key={i}>
                  {partner.name}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
        {currentPartner && (
          <>
            <Row className="center">
              <Col sm={8} md={8}>
                <span className="paragraph-s grey-text">Purchased credits</span>
                <p>{truncateCredits(currentPartner.purchasedCredits)}</p>
              </Col>
              <Col sm={8} md={8}>
                <span className="paragraph-s grey-text">Purchase obligations</span>
                <p>{truncateCredits(currentPartner.purchaseObligations)}</p>
              </Col>
              <Col sm={8} md={8}>
                <span className="paragraph-s grey-text">Remaining credits</span>
                <p>{truncateCredits(remainingPartnerCredits)}</p>
              </Col>
            </Row>
            <Row>
              <Col sm={24} md={12}>
                <InputNumber label="Category1" name="category1" disabled rules={[{ required: true }]} message={"This is required"} defaultValue={category1} />
              </Col>
              <Col sm={24} md={12}>
                <InputNumber label="Category2" name="category2" disabled rules={[{ required: true }]} message={"This is required"} defaultValue={category2} />
              </Col>
              <Col sm={24} md={12}>
                <InputNumber label="Category3" name="category3" disabled rules={[{ required: true }]} message={"This is required"} defaultValue={category3} />
              </Col>
              <Col sm={24} md={12}>
                <InputNumber label="Category4" name="category4" disabled rules={[{ required: true }]} message={"This is required"} defaultValue={category4} />
              </Col>
              <Col sm={24} md={12}>
                <Select initialValue={"Offsetting"} name="creditType" label="creditType" rules={[{ required: true }]}>
                  <Option value={"Insetting"}>Insetting</Option>
                  <Option value={"Offsetting"}>Offsetting</Option>
                </Select>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button block type="primary" htmlType="submit" disabled={loading} loading={loading}>
                  {currentPartner ? `Assign credits to ${currentPartner.name}` : "Assign credits"}
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Form>
    </Drawer>
  );
};
